export default function() {
  let size = 0;
  for (const node of this) ++size; // eslint-disable-line no-unused-vars
  return size;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/size.js
// module id = 4513
// module chunks = 0